import { settings, updateSetting, resetSettings } from "../state/store";

const label = "block text-sm font-medium text-lw-text mb-1";
const input =
  "w-full border border-lw-border rounded-md px-3 py-2 bg-lw-surface focus:outline-none focus:ring-2 focus:ring-lw-blue/40 focus:border-lw-blue";

export const SettingsPage = () => {
  const data = settings.value;

  return (
    <div className="max-w-2xl mx-auto bg-lw-surface rounded-2xl border border-lw-border shadow-sm p-6">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-xl font-semibold text-lw-navy">Global Settings</h3>
        <button
          className="text-sm text-lw-red border border-lw-red/40 hover:bg-lw-red-soft px-3 py-1 rounded-full"
          onClick={resetSettings}
        >
          Reset to Defaults
        </button>
      </div>

      <div className="mb-4">
        <label className={label}>Annual Interest Rate (%)</label>
        <input
          type="number"
          step="any"
          className={input}
          placeholder="5.0"
          value={data.annualInterestRate}
          onInput={(e) => updateSetting("annualInterestRate", e.currentTarget.value)}
        />
      </div>

      <div className="mb-4">
        <label className={label}>Monthly Extra Costs (kr)</label>
        <input
          type="number"
          step="any"
          className={input}
          placeholder="1000"
          value={data.monthlyExtraCosts}
          onInput={(e) => updateSetting("monthlyExtraCosts", e.currentTarget.value)}
        />
        <div className="mt-1 text-xs text-lw-text/60">
          e.g. insurance, service agreements
        </div>
      </div>

      <div className="mb-4">
        <label className={label}>Promotion Deduction (kr)</label>
        <input
          type="number"
          step="any"
          className={input}
          placeholder="1000"
          value={data.promotionDeduction}
          onInput={(e) => updateSetting("promotionDeduction", e.currentTarget.value)}
        />
      </div>

      <hr className="border-lw-border my-6" />
      <h4 className="text-lg font-semibold text-lw-navy mb-4">
        Mileage Allowances
      </h4>

      <div className="mb-4">
        <label className={label}>Tax-free mileage allowance (kr/km)</label>
        <input
          type="number"
          step="any"
          className={input}
          placeholder="2.5"
          value={data.taxFreeMileageAllowance}
          onInput={(e) => updateSetting("taxFreeMileageAllowance", e.currentTarget.value)}
        />
      </div>

      <div className="mb-4">
        <label className={label}>Taxed mileage allowance (kr/km)</label>
        <input
          type="number"
          step="any"
          className={input}
          placeholder="1.2"
          value={data.taxedMileageAllowance}
          onInput={(e) => updateSetting("taxedMileageAllowance", e.currentTarget.value)}
        />
      </div>

      <div className="mb-4">
        <label className={label}>Tax-exempt fuel compensation rate (kr/km)</label>
        <input
          type="number"
          step="any"
          className={input}
          placeholder="1.2"
          value={data.fuelCompensationRate}
          onInput={(e) => updateSetting("fuelCompensationRate", e.currentTarget.value)}
        />
      </div>

      <div className="bg-lw-blue/10 border border-lw-blue/40 text-lw-navy rounded-lg p-4 mt-6 text-sm">
        Settings are automatically saved in your browser's local storage.
      </div>
    </div>
  );
};
